import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CCrud from "components/Molecules/Crud";
import { initialValues, structure, validationSchema } from "./structure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Button, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import AddIcon from "@mui/icons-material/Add";
import { detailsData } from "./details";
import ConfirmationModal from "../../../components/Molecules/Models/ConfirmationModal";
import { useThemePalette } from "../../../common/hooks/theme_palette";

const CustomerComplaintsTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  deleteFun,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  setOpenDeleteModal,
  handleDeleteRequest,
  rolesOptions,
  handleConfirmation,
  confirmBtnTitle,
  color,
  btnColor,
  can_create,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { red } = useThemePalette();

  console.log(confirmBtnTitle, color, btnColor);
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const handleClick = () => {
    setOpenConfirmationModal(!openConfirmationModal);
  };
  const handleBackward = () => {
    navigate("/customer-complaints");
  };

  const [supportedLang] = useState("en");
  return (
    <>
      <Box>
        <Stack
          direction="row"
          alignSelf="start"
          justifyContent="start"
          gap={2}
          width="100%"
          //  mb={1}
        >
          <Breadcrumb data={breadcrumbs} />
        </Stack>
        <CCrud
          detailsTemplateData={{
            pageTitle: t("complaints.details_title"),
            isBackward: true,
            backwardBtn: handleBackward,
            children:
              details?.status === "open" ? (
                <Button
                  variant={"outlined"}
                  sx={{
                    color: "black",
                    borderColor: "black",
                    background: "white",
                    "&:hover": { borderColor: "black", background: "white" },
                  }}
                  onClick={handleClick}
                >
                  {t("complaints.mark_as_resolved")}
                </Button>
              ) : (
                <Button
                  variant={"outlined"}
                  sx={{
                    color: "red",
                    borderColor: "red",
                    "&:hover": {
                      borderColor: "red",
                      background: "transparent",
                    },
                  }}
                  onClick={handleClick}
                >
                  {t("complaints.unresolved")}
                </Button>
              ),
            deleteBtn: false,
            editBtn: false,
            data: {
              list: detailsData({ data: details, t }),
            },
          }}
          table={{
            list: data,
            listTitle: t("complaints.customer_complaints_title"),
            CreateBtnIcon: AddIcon,
            createBtnFun: () => navigate("?type=form"),
            columns: [
              { accessor: "id", Header: "#" },
              {
                accessor: "customer.name",
                Header: t("complaints.customer_name"),
                sort: true,
              },
              {
                accessor: "order_id",
                Header: t("complaints.order_number"),
                sort: true,
              },
              {
                accessor: "created_at",
                Header: t("complaints.date_and_time"),
                sort: true,
              },
              {
                accessor: "status",
                Header: t("complaints.status"),
                sort: true,
              },
              { accessor: "Actions", Header: t("common.action_actions") },
            ],
            isSearch: false,
            searchInputPlaceholder: t("complaints.search_placeholder"),
            isChecked: false,
            total_count: count,
            isSort: true,
            setFilterObj,
            className:
              "organization-table system-configurations-table main-table",
            paginationPage: paginationPage,
            handlePageChange,
            rowData: rowData,
            filterList,
            actionsList, //if you want to add custom actions list
            headerChildren,

            details,
            openDeleteModal,
            setOpenDeleteModal,
            handleDeleteRequest,
          }}
          form={{
            initialValues: !id ? {} : initialValues(details, supportedLang),
            structure: () => structure(supportedLang, rolesOptions),
            validationSchema: validationSchema,
            deleteFun: deleteFun,
            title: id ? "Edit User" : "New User",
            submitTitle: id ? "Update" : "Add",
            onSubmit: handelSubmit,
            className: { form: "main-form", actionButton: "main-form-buttons" },
          }}
          // DetailsComponent={<Details />} //to send details component diff from the default
          modalComponents={modalComponents}
        />
        {openConfirmationModal && (
          <ConfirmationModal
            open={openConfirmationModal}
            setOpen={setOpenConfirmationModal}
            handleCancellation={() => setOpenConfirmationModal(false)}
            text={[
              t("complaints.mark_complain_as", {
                status:
                  details?.status === "open"
                    ? t("complaints.resolved")
                    : t("complaints.unresolved"),
              }),
              t("complaints.confirm_mark_complain_as", {
                status:
                  details?.status === "open"
                    ? t("complaints.resolved")
                    : t("complaints.unresolved"),
              }),
            ]}
            confirmBtnTitle={
              details?.status === "open"
                ? t("complaints.resolved")
                : t("complaints.unresolved")
            }
            color={"black"}
            btnColor={details?.status === "open" ? "#3FABAE" : red}
            handleConfirmation={handleConfirmation}
          ></ConfirmationModal>
        )}
      </Box>
    </>
  );
};

export default CustomerComplaintsTemplate;
